import React from 'react';
import SalesFilter from './SalesFilter';
import SalesTotal from './SalesTotal';
import SalesTable from './SalesTable';
import { Row, Col, Card, Spin } from 'antd';
import { useReportsStore } from '../../store/slices/createReportsSlice';

export default function BusinessSaleReport() {
    const reports = useReportsStore()
    const loading = reports.sales.loading;
    return (
        <Spin spinning={loading}>
            <Card>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <SalesFilter />
                        <SalesTotal />
                        <SalesTable />
                    </Col>
                </Row>
            </Card>
        </Spin >
    )
}
